import styled from 'styled-components';
// import Button from '@material-ui/core/Button';
import { CandyMachineAccount } from './candy-machine';
import { CircularProgress } from '@material-ui/core';
import { GatewayStatus, useGateway } from '@civic/solana-gateway-react';
import { useEffect, useState, useRef } from 'react';
import { useConnection, useWallet } from '@solana/wallet-adapter-react';
import {
  findGatewayToken,
  getGatewayTokenAddressForOwnerAndGatekeeperNetwork,
  onGatewayTokenChange,
  removeAccountChangeListener,
} from '@identity.com/solana-gateway-ts';
import { Button, Row, Col } from 'antd';
import { COLOR, FONT } from './constants';
import _ from 'lodash'

import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";

export const CTAButton = styled(Button)`
  width: 100%;
  height: 60px;
  margin-top: 10px;
  margin-bottom: 5px;
  background: linear-gradient(180deg, #604ae5 0%, #813eee 100%);
  color: white;
  font-size: 16px;
  font-weight: bold;
`; // add your own styles here

const StyledButton = styled(Button)`
  &:hover {
    background-color: ${COLOR.content} !important;
    border: 3px solid #000000 !important;
    box-shadow: 6px 7px 0px #000000 !important;
    border-radius: 8px !important;
  }
`

const ConnectButton = styled(WalletMultiButton)`
  margin: 0 auto;
  &:hover {
    background-color: ${COLOR.content} !important;
    border: 3px solid #000000 !important;
    box-shadow: 6px 7px 0px #000000 !important;
    border-radius: 8px !important;
  }
`;

export const MintButton = ({
  onMint,
  candyMachine,
  isMinting,
  isEnded,
  isActive,
  isSoldOut,
  setClicked,
  clicked,
  success,
  setModalVisible,
  setIsMinting,
  setAlertState,
  download,
  downloadLoading
}: {
  onMint: () => Promise<void>;
  candyMachine: CandyMachineAccount | undefined;
  isMinting: boolean;
  isEnded: boolean;
  isActive: boolean;
  isSoldOut: boolean;
  setClicked: (clicked: boolean) => void;
  setIsMinting: (bool: boolean) => void;
  setModalVisible: (visible: boolean) => void;
  clicked: boolean;
  success: boolean;
  setAlertState: (state: object) => void;
  download: () => Promise<void>;
  downloadLoading: boolean;
}) => {
  const wallet = useWallet();
  const connection = useConnection();
  const [verified, setVerified] = useState(false);
  const { requestGatewayToken, gatewayStatus } = useGateway();
  const [webSocketSubscriptionId, setWebSocketSubscriptionId] = useState(-1);
  const [isVerifying, setIsVerifying] = useState(false);


  useEffect(() => {
    const mint = async () => {
      await removeAccountChangeListener(
        connection.connection,
        webSocketSubscriptionId,
      );
      await onMint();

      setClicked(false);
      setVerified(false);
    };
    if (verified && clicked) {
      mint();
    }
  }, [
    verified,
    clicked,
    connection.connection,
    onMint,
    webSocketSubscriptionId,
    setClicked
  ]);

  const previousGatewayStatus = usePrevious(gatewayStatus);
  useEffect(() => {
    (async () => {
      // console.log('cp01', gatewayStatus)
      setIsVerifying(false);
      if (gatewayStatus === GatewayStatus.COLLECTING_USER_INFORMATION && clicked) {
        // when user approves wallet verification txn
        setIsVerifying(true);
      }

      const fromStates = [
        GatewayStatus.NOT_REQUESTED,
        GatewayStatus.REFRESH_TOKEN_REQUIRED,
      ];
      const invalidToStates = [...fromStates, GatewayStatus.UNKNOWN];
      if (
        fromStates.find(state => previousGatewayStatus === state) &&
        !invalidToStates.find(state => gatewayStatus === state)
      ) {
        setIsMinting(true);
      }



      // if (gatewayStatus === GatewayStatus.ACTIVE && clicked) {
      //   console.log('Verified human, now minting...');
      //   await onMint();
      //   setClicked(false);
      // }

      // console.log('change: ', gatewayStatus);
    })();
  }, [setIsMinting, previousGatewayStatus, gatewayStatus, clicked, onMint, setClicked]);

  const renderButton = () => {
    // success button
    console.log('success', success);
    if (success) {
      return (
        <Row>
          <Col xs={0} sm={0} md={24} lg={24}>
            <StyledButton loading={downloadLoading} disabled={downloadLoading} style={{ ...styles.btn }} onClick={async () => {
              await download()
            }}>
              Download
            </StyledButton></Col>
        </Row>
      )
    }

    const disabled = (
      clicked ||
      candyMachine?.state.isSoldOut ||
      isSoldOut ||
      isMinting ||
      isEnded ||
      !isActive ||
      isVerifying
    )

    if (!candyMachine && (_.isEmpty(wallet) || !wallet?.connected)) {
      return <ConnectButton style={styles.btn} />
      // return <StyledButton style={styles.btn} disabled={disabled}>CONNECTING...</StyledButton>
    }

    if (candyMachine?.state.isSoldOut || isSoldOut) {
      return null;
      // return <Button style={styles.btn} disabled={disabled}>SOLD OUT</Button>
    }

    if (isActive) {
      if (isVerifying) {
        return <StyledButton style={styles.btn} disabled={disabled}>VERIFYING...</StyledButton>
      }

      if (isMinting || clicked) {
        return <StyledButton style={styles.btn} disabled={disabled}>Minting...</StyledButton>
      }
      return <StyledButton
        style={styles.btn}
        disabled={disabled}
        onClick={async () => {
          if (candyMachine?.state?.isActive) {
            // Active and Gatekeeper enabled
            if (candyMachine?.state.gatekeeper) {
              const network =
                candyMachine?.state?.gatekeeper?.gatekeeperNetwork?.toBase58();
              if (network === 'ignREusXmGrscGNUesoU9mxfds9AiYTezUKex2PsZV6') {
                if (gatewayStatus === GatewayStatus.ACTIVE) {
                  setClicked(true);
                  await onMint();
                  setClicked(false)
                } else {
                  // setIsMinting(true);
                  await requestGatewayToken();
                  console.log('after: ', gatewayStatus);
                }
              }

              return;
            }


            setClicked(true);
            await onMint();
            setClicked(false)
          }
        }}
      >
        Mint Your Shiba9!
      </StyledButton >
    }

    if (isEnded) {
      return <StyledButton style={styles.btn} disabled={disabled}>ENDED</StyledButton>
    }

    if (candyMachine?.state.goLiveDate) {
      return <StyledButton style={styles.btn} disabled={disabled}>SOON</StyledButton>
    }

    return <StyledButton style={styles.btn} disabled={disabled}>UNAVAILABLE</StyledButton>
  }

  return (renderButton());

  // return (
  //   <CTAButton
  //     disabled={isMinting || !isActive}
  //     onClick={async () => {
  //       if (candyMachine?.state.isActive && candyMachine?.state.gatekeeper) {
  //         const network =
  //           candyMachine.state.gatekeeper.gatekeeperNetwork.toBase58();
  //         if (network === 'ignREusXmGrscGNUesoU9mxfds9AiYTezUKex2PsZV6') {
  //           if (gatewayStatus === GatewayStatus.ACTIVE) {
  //             await onMint();
  //           } else {
  //             // setIsMinting(true);
  //             await requestGatewayToken();
  //             console.log('after: ', gatewayStatus);
  //           }
  //         } else if (
  //           network === 'ttib7tuX8PTWPqFsmUFQTj78MbRhUmqxidJRDv4hRRE' ||
  //           network === 'tibePmPaoTgrs929rWpu755EXaxC7M3SthVCf6GzjZt'
  //         ) {
  //           setClicked(true);
  //           const gatewayToken = await findGatewayToken(
  //             connection.connection,
  //             wallet.publicKey!,
  //             candyMachine.state.gatekeeper.gatekeeperNetwork,
  //           );

  //           if (gatewayToken?.isValid()) {
  //             await onMint();
  //           } else {
  //             window.open(
  //               `https://verify.encore.fans/?gkNetwork=${network}`,
  //               '_blank',
  //             );

  //             const gatewayTokenAddress =
  //               await getGatewayTokenAddressForOwnerAndGatekeeperNetwork(
  //                 wallet.publicKey!,
  //                 candyMachine.state.gatekeeper.gatekeeperNetwork,
  //               );

  //             setWebSocketSubscriptionId(
  //               onGatewayTokenChange(
  //                 connection.connection,
  //                 gatewayTokenAddress,
  //                 () => setVerified(true),
  //                 'confirmed',
  //               ),
  //             );
  //           }
  //         } else {
  //           setClicked(false);
  //           throw new Error(`Unknown Gatekeeper Network: ${network}`);
  //         }
  //       } else {
  //         await onMint();
  //         setClicked(false);
  //       }
  //     }}
  //     variant="contained"
  //   >
  //     {getMintButtonContent()}
  //   </CTAButton>
  // );
};

function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

const styles = {
  btn: {
    ...FONT.h5, backgroundColor: COLOR.textSecondary, color: COLOR.secondary, height: 60, borderRadius: 8, width: '100%'
  },
  successBtn: {
    minHeight: 70, width: '100%', borderRadius: 12, fontSize: 20, color: '#fff', fontWeight: 'bold',
    fontFamily: 'Orbitron',
    background: 'linear-gradient(95.97deg, #BD7AEF 3.45%, #BD7AEF 26.67%, #E9A5D4 53.2%, #D390E2 78.62%, #BD7AEF 104.05%)'

  }
}

// gateway status
// {
//   "0": "UNKNOWN",
//   "1": "CHECKING",
//   "2": "NOT_REQUESTED",
//   "3": "COLLECTING_USER_INFORMATION",
//   "4": "PROOF_OF_WALLET_OWNERSHIP",
//   "5": "IN_REVIEW",
//   "6": "REJECTED",
//   "7": "REVOKED",
//   "8": "FROZEN",
//   "9": "ACTIVE",
//   "10": "ERROR",
//   "11": "LOCATION_NOT_SUPPORTED",
//   "12": "REFRESH_TOKEN_REQUIRED",
//   "13": "VALIDATING_USER_INFORMATION",
//   "14": "USER_INFORMATION_VALIDATED",
//   "15": "USER_INFORMATION_REJECTED",
//   "UNKNOWN": 0,
//   "CHECKING": 1,
//   "NOT_REQUESTED": 2,
//   "COLLECTING_USER_INFORMATION": 3,
//   "PROOF_OF_WALLET_OWNERSHIP": 4,
//   "IN_REVIEW": 5,
//   "REJECTED": 6,
//   "REVOKED": 7,
//   "FROZEN": 8,
//   "ACTIVE": 9,
//   "ERROR": 10,
//   "LOCATION_NOT_SUPPORTED": 11,
//   "REFRESH_TOKEN_REQUIRED": 12,
//   "VALIDATING_USER_INFORMATION": 13,
//   "USER_INFORMATION_VALIDATED": 14,
//   "USER_INFORMATION_REJECTED": 15
// }